export default __webpack_public_path__ + "static/media/feed.2a299205.jpg";